module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.51cf1d6.ttf";